module.exports = __webpack_public_path__ + "static/media/edit-icon.a2a2ce8a.svg";